// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-20d4c56e] .el-dialog {\n  max-width: 800px;\n  margin-bottom: 0;\n}\n[data-v-20d4c56e] .el-dialog__body {\n  margin-bottom: -20px;\n}\n[data-v-20d4c56e] .checkbox-list {\n  max-height: calc(100vh - 400px);\n  overflow: auto;\n}\n[data-v-20d4c56e] .el-checkbox {\n  display: block;\n}\n.column-heading[data-v-20d4c56e] {\n  font-size: 16px;\n  margin-bottom: 15px;\n  font-weight: bold;\n}", ""]);
// Exports
module.exports = exports;
